var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent, Component } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import { each, isArray, isEqual, isObject, map } from 'lodash';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { services } from '@comall-backend-builder/core'; // import './index.scss';
// @ts-ignore

import loadingUrl from './loading.gif';
import { Tooltip as AntTooltip } from 'antd';
var SIZE_LIST = ['10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px'];
var richTextFormats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'list', 'bullet', 'script', 'indent', 'direction', 'size', 'color', 'background', 'font', 'align', 'link', 'image', 'video'];
var modules = [[{
  header: [1, 2, 3, 4, 5, 6, 0]
}], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{
  header: '1'
}, {
  header: '2'
}], [{
  list: 'ordered'
}, {
  list: 'bullet'
}], [{
  script: 'sub'
}, {
  script: 'super'
}], [{
  indent: '-1'
}, {
  indent: '+1'
}], [{
  direction: 'rtl'
}], [{
  size: SIZE_LIST
}], [{
  color: []
}, {
  background: []
}], [{
  font: []
}], [{
  align: []
}], ['link', 'image'], ['video'], ['clean']]; //quill的调整图片大小模块需要全局的quill变量

window.Quill = Quill;

var ImageResize = require('quill-image-resize-module');

Quill.register('modules/ImageResize', ImageResize);
var Size = Quill.import('attributors/style/size');
Size.whitelist = SIZE_LIST;
Quill.register(Size, true);

function getObjectFirstKey(object) {
  return Reflect.ownKeys(object)[0];
}

var id = 0;

function generateToolbarId() {
  var toolbarId = 'toolbar-' + id;
  id++;
  return toolbarId;
}

var EditorModules = function (_super) {
  __extends(EditorModules, _super);

  function EditorModules() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 渲染具有下拉选项的toolbar
   * @param {String} keyName quill中的toolbar名称，需要渲染成ql-{keyName}的格式
   * @param {Array} value
   * @return {ReactElement}
   */


  EditorModules.renderSelectableBar = function (keyName, value) {
    return React.createElement("span", null, React.createElement("select", {
      className: "ql-" + keyName
    }, map(value, function (option, optionIndex) {
      return React.createElement("option", {
        key: optionIndex,
        value: option
      });
    })));
  };
  /**
   * 渲染format中的每一个toolbar以及其对应的tooltip
   * @param {Object|String} format
   * @param {Number} toolIndex
   * @return {ReactElement}
   */


  EditorModules.renderToolBarWithTip = function (format, toolIndex) {
    var renderedComponent;
    var keyName = '';
    var tipKey = '';

    if (!isObject(format)) {
      keyName = format;
      tipKey = format; //最简单的字符串，渲染成指定class的button

      renderedComponent = React.createElement("button", {
        className: "ql-" + keyName
      });
    } else {
      keyName = getObjectFirstKey(format);
      var value = format[keyName];

      if (isArray(value)) {
        tipKey = keyName; //对象值为数组时，渲染成指定class的下拉bar

        renderedComponent = EditorModules.renderSelectableBar(keyName, value);
      } else {
        tipKey = "" + keyName + value; //对象值为非数组时，渲染成指定class并带有特定值的button

        renderedComponent = React.createElement("button", {
          className: "ql-" + keyName,
          value: value
        });
      }
    }

    var TOOLTIPS = services.language.getText('components.RichText.tooltips');
    return React.createElement(AntTooltip, {
      key: toolIndex,
      title: TOOLTIPS[tipKey]
    }, renderedComponent);
  };
  /**
   * 根据modules中的每一项渲染一组format，
   * @return {Array<ReactElement>}
   * @param {Array} formats
   */


  EditorModules.renderFormats = function (formats) {
    return map(formats, function (format, toolIndex) {
      return EditorModules.renderToolBarWithTip(format, toolIndex);
    });
  };

  EditorModules.prototype.render = function () {
    var toolbarId = this.props.toolbarId;
    return React.createElement("div", {
      id: toolbarId
    }, map(modules, function (formats, formatIndex) {
      return React.createElement("span", {
        key: formatIndex,
        className: "ql-formats"
      }, EditorModules.renderFormats(formats));
    }));
  };

  return EditorModules;
}(PureComponent);

var RichText = function (_super) {
  __extends(RichText, _super);

  function RichText(props) {
    var _this = _super.call(this, props) || this;

    _this.createQuillRef = function (e) {
      return _this.quillRef = e;
    };
    /**
     * 富文本上传图片时默认是base64编码，需要将其进行文件上传，并根据上传返回的图片地址显示在富文本中
     */


    _this.imageHandler = function () {
      var _a = _this.props,
          imagePlaceholder = _a.imagePlaceholder,
          uploadConfig = _a.uploadConfig;
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.setAttribute('class', 'hide');
      input.setAttribute('multiple', 'multiple');
      document.body.appendChild(input);
      input.click();

      var editor = _this.quillRef.getEditor();

      input.onchange = function (event) {
        var target = event.target;
        var files = target.files;
        var range = editor.getSelection(true);
        var success = 0;
        var finish = 0; //防止清空loading图后索引变化导致删除的位置错误，此处记录并在请求结束后统一进行删除

        var errorIndexs = [];
        each(files, function (_file, index) {
          var cursor = index + range.index; //在此放置一个过渡用内容，暂时只支持图片形式的过渡

          editor.insertEmbed(cursor, 'image', imagePlaceholder);
          editor.setSelection(cursor + 1);
          services.api.upload({
            files: files[index]
          }, uploadConfig).then(function (response) {
            editor.deleteText(cursor, 1);
            editor.insertEmbed(cursor, 'image', response.path);
            success++;
          }).catch(function () {
            //请求失败后也要清空loading图，防止误解仍在上传中。
            errorIndexs.push(cursor);
          }).finally(function () {
            finish++;

            if (finish >= files.length) {
              //删除时需要从大到小的进行删除，所以先排序
              each(errorIndexs.sort(function (before, after) {
                return after - before;
              }), function (errorIndex) {
                editor.deleteText(errorIndex, 1);
              }); //为了确保所有请求完毕后，光标处于正确的位置

              editor.setSelection(range.index + success);
            }
          });
        });
      };

      document.body.removeChild(input);
    };

    _this.formats = richTextFormats;
    _this.toolbarId = generateToolbarId();
    _this.handleChange = _this.handleChange.bind(_this);
    _this.richTextModules = {
      imageResize: {},
      toolbar: {
        container: "#" + _this.toolbarId,
        handlers: {
          image: _this.imageHandler
        }
      }
    };
    return _this;
  }

  RichText.prototype.handleChange = function (html) {
    var _a = this.props,
        onChange = _a.onChange,
        name = _a.name;

    if (onChange) {
      onChange(html, name);
    }
  };

  RichText.prototype.shouldComponentUpdate = function (nextProps, _nextState) {
    return !isEqual(this.props, nextProps);
  };

  RichText.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseInput') : _b,
        disabled = _a.disabled,
        className = _a.className,
        style = _a.style;
    var props = {
      theme: disabled ? 'bubble' : 'snow',
      onChange: this.handleChange,
      modules: this.richTextModules,
      formats: this.formats,
      placeholder: placeholder,
      readOnly: disabled,
      className: className,
      style: style,
      value: value || '',
      ref: this.createQuillRef
    };
    return React.createElement("div", {
      className: "quill-editor"
    }, React.createElement(EditorModules, {
      toolbarId: this.toolbarId
    }), React.createElement(ReactQuill, __assign({}, props)));
  };

  RichText.defaultProps = {
    theme: 'snow',
    disabled: false,
    imagePlaceholder: loadingUrl
  };
  return RichText;
}(Component);

export { RichText };